import { render, staticRenderFns } from "./_creator-detail.vue?vue&type=template&id=f4583c1a"
import script from "./_creator-detail.vue?vue&type=script&lang=js"
export * from "./_creator-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports